<mat-select class="date-menu" [(ngModel)]="selectedMatSelectValue" (selectionChange)="changedMatSelectionValue($event.value)">
  <mat-option [value]="matSelectFields.daily">Daily</mat-option>
  <mat-option [value]="matSelectFields.weekly">Weekly</mat-option>
  <mat-option [value]="matSelectFields.monthly">Monthly</mat-option>
</mat-select>

